<template>
    <div v-if='projects' >
        <div class="Modal__header">
            <h3>Supprimer les parcours ?</h3>
        </div>

        <div class="Modal__body"  >
            <p>Vous êtes sur le point de supprimer définitivement les <!--{{ projects.length }}--> parcours.</p>
            <p>Toutes les données relatives à ces parcours seront également supprimées.</p>
        </div>

        <div class="Modal__footer">
            <button class="Modal__buton-ok" @click="cancel()">
                Annuler
            </button>
            <button class="Modal__buton-danger" @click="confirm()">
                Supprimer
            </button>
        </div>
    </div>
</template>

<script>
    /* See https://adamwathan.me/2016/01/04/composing-reusable-modal-dialogs-with-vuejs/ */
    import { deleteProject } from '../../vuex/actions/projectActions'

    export default{
      props: ['projects'],
      vuex: {
        actions: {
          deleteProject
        }
      },
      data () {
        return {}
      },
      methods: {
        cancel () {
          this.$dispatch('closeModal')
        },
        confirm () {
          let that = this
          this.projects.forEach(function (project) {
            that.deleteProject(project)
          })
          this.$dispatch('closeModal')
          this.$dispatch('after-delete-projects')
          this.$dispatch('preview-data', [])
        }
      }
}
</script>



// WEBPACK FOOTER //
// DeleteProjects.vue?151a7fc0